import { Grid, Typography } from '@mui/material';
import {
  CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { Contrato } from '@/shared/interfaces';
import { gridSizeMdLg12 } from '@/shared';
import dayjs from 'dayjs';
import { useGetObservacionesPorContrato } from '@/shared/actions/erp';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  contract?: Contrato;
}
const ModalVerHistorialObservacionesNuevaFormato: React.FC<
  ConfirmRejectOTDialogProps
> = ({ open, setOpen, contract }) => {
  const handleClose = () => setOpen(false);

  // 🔹 Observaciones antiguas (NO se tocan)
  const todasObservaciones =
    contract?.observaciones_contrato?.contenido || [];

  const observacionesAntiguas = todasObservaciones.filter(
    (item) => !(item as typeof item & { migrado?: boolean }).migrado
  );

  // 🔹 Observaciones nuevas (endpoint nuevo)
  const { data: nuevas_observaciones = [], isLoading } =
    useGetObservacionesPorContrato(contract?.id_contrato, open);


  const colorPorTipo = (tipo?: string) => {
    switch (tipo) {
      case 'VENTAS':
        return '#3c46d4';
      case 'TECNICO':
        return '#c30e54';
      default:
        return '#000000';
    }
  };
  ///ANTIGUAS
  const renderObservaciones = (data: typeof todasObservaciones) =>
    data.map((item, index) => (
      <Grid key={`obs-historial-${index}`} container item xs={12}>
            <Typography variant="h6" pt="1rem" pb="1rem" mt="0">
              Corrección {index + 1}
            </Typography>

        <Grid container item>
          <TabTextLabel text="Motivos" pt="0" pb="18px" pl="0" mt="0" />
          <CustomTextAreaNoForm
            disabled
            label=""
            value={ Array.isArray(item?.motivos)
            ? item.motivos.join('\n')
            : ''}
            size={gridSizeMdLg12}
            rows={3}
          />
        </Grid>

        <Grid container item {...gridSizeMdLg12} sx={{ marginY: "20px" }}>
          <TabTextLabel text="Fecha de Observación" pt="0" pb="18px" pl="0" mt="0" />
          <CustomTextFieldNoForm
            label=""
            value={dayjs(item?.fecha)?.format("LLL")?.toString()}
          />
        </Grid>

        <Grid container item {...gridSizeMdLg12}>
          {item?.observaciones_ventas && (
            <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
              <TabTextLabel text="Observaciones Ventas" pt="0" pb="18px" pl="0" mt="0" />
              <CustomTextAreaNoForm
                disabled
                label=""
                value={item.observaciones_ventas || ""}
                size={gridSizeMdLg12}
                rows={4}
              />
            </Grid>
          )}
          {item?.observaciones_tecnico && (
            <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
              <TabTextLabel text="Observaciones Técnico" pt="0" pb="18px" pl="0" mt="0" />
              <CustomTextAreaNoForm
                disabled
                label=""
                value={item.observaciones_tecnico || item.observaciones || ""}
                size={gridSizeMdLg12}
                rows={4}
              />
            </Grid>
          )}
          {!item?.observaciones_ventas && !item?.observaciones_tecnico && (
            <>
              <TabTextLabel text="Observaciones" pt="0" pb="18px" pl="0" mt="0" />
              <CustomTextAreaNoForm
                disabled
                label=""
                value={item.observaciones || ""}
                size={gridSizeMdLg12}
                rows={4}
              />
            </>
          )}
        </Grid>
        <hr style={{ border: "1px solid #c1c1c1", margin: "20px 0", width: "100%" }} />
      </Grid>
    ));


  // 🔥 NUEVO RENDER SOLO PARA LAS NUEVAS
  const renderNuevasObservaciones = (
    data: typeof nuevas_observaciones
  ) =>
    [...data]
      // .sort(
      //   (a, b) =>
      //     new Date(b.fecha_observacionContrato).getTime() -
      //     new Date(a.fecha_observacionContrato).getTime()
      // )
      .map((item, index) => (
        <Grid key={item.id_contrato_observacion} container item xs={12}>
          <Typography variant="h6" pt="1rem" pb="1rem">
            Corrección {index + 1}
          </Typography>

          {/* Fecha */}
          <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
            <TabTextLabel text="Fecha de Observación" pl="0" />
            <CustomTextFieldNoForm
              label=""
              value={dayjs(item.fecha_observacionContrato).format('LLL')}
            />
          </Grid>

          {/* Descripción */}
          <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
            <TabTextLabel text="Descripción" pl="0" />
            <CustomTextAreaNoForm
              disabled
              label=""
              value={item.descripcion_observacion || ''}
              size={gridSizeMdLg12}
              rows={3}
            />
          </Grid>

          {/* Responsables */}
          <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
            <TabTextLabel text="Áreas Responsables" pl="0" />
            <CustomTextFieldNoForm
              label=""
              value={item.responsables?.join(', ') || ''}
              sxTextField={{
                '& .MuiInputBase-input': {
                  fontWeight: 600,
                },
              }}
            />
          </Grid>

          {/* Motivos agrupados */}
          {Object.entries(item.motivos_detallados || {}).map(
            ([area, motivos]: any) => (
              <Grid
                key={area}
                container
                item
                {...gridSizeMdLg12}
                sx={{ marginY: '10px' }}
              >
                <TabTextLabel
                  text={`Motivos - ${area}`}
                  pl="0"
                  sx={{ color: colorPorTipo(area) }}
                />

                <CustomTextAreaNoForm
                  disabled
                  label=""
                  value={motivos
                    .map((m: any) => `• ${m.nombre_observacion}`)
                    .join('\n')}
                  size={gridSizeMdLg12}
                  rows={motivos.length}
                  // rows={Math.min(motivos.length, 6)} posible cambio
                />
              </Grid>
            )
          )}

          <hr
            style={{
              border: '1px solid #c1c1c1',
              margin: '20px 0',
              width: '100%',
            }}
          />
        </Grid>
      ));

  return (
    <ScrollableDialogProps
      open={open}
      title="Historial de Observaciones"
      cancelTextBtn="Cerrar"
      showConfirmBtn={false}
      onClose={handleClose}
      minWidth="42%"
      contentNode={
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Se presentan a continuación las observaciones realizadas
              históricamente.
            </Typography>
          </Grid>

          {/* Observación asesor */}
          <CustomTextAreaNoForm
            disabled
            label="Observación Asesor"
            defaultValue={
              contract?.observaciones?.observacion_asesor ?? 'N/A'
            }
            value={
              contract?.observaciones?.observacion_asesor ?? 'N/A'
            }
            size={gridSizeMdLg12}
          />

          {/* 🔹 Observaciones Antiguas (sin cambios) */}
          {observacionesAntiguas.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
                Observaciones Antiguas
              </Typography>
              {renderObservaciones(observacionesAntiguas)}
            </Grid>
          )}

          {/* 🔥 Observaciones Nuevas */}
          {nuevas_observaciones.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
                Observaciones Nuevas
              </Typography>

              {isLoading ? (
                <Typography>Cargando...</Typography>
              ) : (
                renderNuevasObservaciones(nuevas_observaciones)
              )}
            </Grid>
          )}
        </Grid>
      }
    />
  );
};

export default ModalVerHistorialObservacionesNuevaFormato;


/** */
// const renderObservaciones = (data: typeof todasObservaciones) =>
//   data.map((item, index) => (
//     <Grid key={`obs-historial-${index}`} container item xs={12}>
//       <Typography variant="h6" pt="1rem" pb="1rem" mt="0">
//         Corrección {index + 1}
//       </Typography>

//       {/* Motivos */}
//       <Grid container item>
//         <TabTextLabel text="Motivos" pt="0" pb="18px" pl="0" mt="0" />
//         <CustomTextAreaNoForm
//           disabled
//           label=""
//           value={
//             Array.isArray(item?.motivos)
//               ? item.motivos.join('\n')
//               : ''
//           }
//           size={gridSizeMdLg12}
//           rows={3}
//         />
//       </Grid>

//       {/* Fecha */}
//       <Grid container item {...gridSizeMdLg12} sx={{ marginY: "20px" }}>
//         <TabTextLabel text="Fecha de Observación" pt="0" pb="18px" pl="0" mt="0" />
//         <CustomTextFieldNoForm
//           label=""
//           value={dayjs(item?.fecha)?.format("LLL")?.toString()}
//         />
//       </Grid>

//       {/* Observaciones */}
//       <Grid container item {...gridSizeMdLg12}>
//         {item?.observaciones_ventas && (
//           <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
//             <TabTextLabel text="Observaciones Ventas" pl="0" />
//             <CustomTextAreaNoForm
//               disabled
//               label=""
//               value={item.observaciones_ventas || ""}
//               size={gridSizeMdLg12}
//               rows={4}
//             />
//           </Grid>
//         )}

//         {item?.observaciones_tecnico && (
//           <Grid container item {...gridSizeMdLg12} sx={{ marginY: "10px" }}>
//             <TabTextLabel text="Observaciones Técnico" pl="0" />
//             <CustomTextAreaNoForm
//               disabled
//               label=""
//               value={item.observaciones_tecnico || item.observaciones || ""}
//               size={gridSizeMdLg12}
//               rows={4}
//             />
//           </Grid>
//         )}

//         {!item?.observaciones_ventas && !item?.observaciones_tecnico && (
//           <>
//             <TabTextLabel text="Observaciones" pl="0" />
//             <CustomTextAreaNoForm
//               disabled
//               label=""
//               value={item.observaciones || ""}
//               size={gridSizeMdLg12}
//               rows={4}
//             />
//           </>
//         )}
//       </Grid>

//       <hr
//         style={{
//           border: "1px solid #c1c1c1",
//           margin: "20px 0",
//           width: "100%",
//         }}
//       />
//     </Grid>
//   ));

//   const renderNuevasObservaciones = (data: typeof nuevas_observaciones) =>
//   [...data]
//     .sort(
//       (a, b) =>
//         new Date(b.fecha_observacionContrato).getTime() -
//         new Date(a.fecha_observacionContrato).getTime()
//     )
//     .map((item, index) => (
//       <Grid key={item.id_contrato_observacion} container item xs={12}>
//         <Typography variant="h6" pt="1rem" pb="1rem">
//           Corrección {index + 1} - {item.codigo}
//         </Typography>

//         {/* Fecha */}
//         <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
//           <TabTextLabel text="Fecha de Observación" pl="0" />
//           <CustomTextFieldNoForm
//             label=""
//             value={dayjs(item.fecha_observacionContrato).format('LLL')}
//           />
//         </Grid>

//         {/* Descripción */}
//         <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
//           <TabTextLabel text="Descripción" pl="0" />
//           <CustomTextAreaNoForm
//             disabled
//             label=""
//             value={item.descripcion_observacion || ''}
//             size={gridSizeMdLg12}
//             rows={3}
//           />
//         </Grid>

//         {/* Responsables */}
//         <Grid container item {...gridSizeMdLg12} sx={{ mb: 2 }}>
//           <TabTextLabel text="Áreas Responsables" pl="0" />
//           <CustomTextFieldNoForm
//             label=""
//             value={item.responsables?.join(', ') || ''}
//           />
//         </Grid>

//         {/* Motivos agrupados */}
//         {Object.entries(item.motivos_detallados || {}).map(
//           ([area, motivos]: any) => (
//             <Grid
//               key={area}
//               container
//               item
//               {...gridSizeMdLg12}
//               sx={{ marginY: '10px' }}
//             >
//               <TabTextLabel text={`Motivos - ${area}`} pl="0" />

//               <CustomTextAreaNoForm
//                 disabled
//                 label=""
//                 value={motivos
//                   .map((m: any) => `• ${m.nombre_observacion}`)
//                   .join('\n')}
//                 size={gridSizeMdLg12}
//                 rows={Math.min(motivos.length, 6)}
//               />
//             </Grid>
//           )
//         )}

//         <hr
//           style={{
//             border: '1px solid #c1c1c1',
//             margin: '20px 0',
//             width: '100%',
//           }}
//         />
//       </Grid>
//     ));